import React from "react";
import { View, Text, Button, TextInput, Icon } from "ui";
import { memoMutations } from "api";
import { notify } from "shared/services";
import { Dialog, Radio, FormControlLabel, RadioGroup } from "@material-ui/core";
import { styled } from "styles";
import { Category } from "types";
interface P {
  onClose: () => void;
  categories: Category[];
}

export default class AddMemoModal extends React.Component<P> {
  public state = {
    name: "",
    categoryId: undefined
  };

  public handleClose = () => {
    this.setState({ name: "" });
    this.props.onClose();
  }

  public render = () => {
    const { name, categoryId } = this.state;

    return (
      <Dialog open onClose={this.handleClose}>
        <View p={2} bg="white" alignItems="center" flexDirection="column">
          <View flexDirection="row" alignItems="center">
            <Text fontSize={4} mr={5}>
              Adauga Memo
            </Text>
            <CloseButton onClick={this.handleClose}>
              <Icon name="close-circle" size={2} />
            </CloseButton>
          </View>
          <View mt={2} flexDirection="row">
            <memoMutations.CreateMemo>
              {create => (
                <form
                  onSubmit={async e => {
                    e.preventDefault();
                    try {
                      const res = await create({
                        variables: { name, categoryId }
                      });
                      if (res && res.data) {
                        notify("Memo-ul a fost creat.");
                        this.handleClose();
                      }
                    } catch (err) {}
                  }}
                >
                  <View>
                    <TextInput
                      placeholder="Nume memo"
                      height="2rem"
                      onChange={e => this.setState({ name: e.target.value })}
                    />
                  </View>
                  <Button
                    width="100%"
                    border="none"
                    as="button"
                    type="submit"
                    mt={2}
                    mb={2}
                    onClick={() => this.setState({ categoryId: 1 })}
                  >
                    <Text fontSize={2} color="white">
                      + Vehicul
                    </Text>
                  </Button>
                  <Button
                    width="100%"
                    border="none"
                    as="button"
                    type="submit"
                    mt={2}
                    mb={2}
                    onClick={() => this.setState({ categoryId: 2 })}
                  >
                    <Text fontSize={2} color="white">
                      + Altele
                    </Text>
                  </Button>

                  <InfoView
                    alignSelf="center"
                    flexDirection="column"
                    mt={10}
                    borderRadius={10}
                    width="12rem"
                  >
                    <Text>
                      * Memo Vehicul creeaza o lista predefinita de alerte
                      pentru tine, cum ar fi RCA, ITP, Rovinienta, Casco, etc.
                      In acest fel, ai totul pregatit si nu risti sa omiti o
                      alerta importanta. Bineinteles, le poti modifica, sterge
                      sau adauga alte alerte.
                    </Text>
                    <Text>
                      * Memo Altele NU creeaza o lista predefinita, ea iti ofera
                      optiunea de a creea alertele de la zero.
                    </Text>
                  </InfoView>
                </form>
              )}
            </memoMutations.CreateMemo>
          </View>
        </View>
      </Dialog>
    );
  }
}

const CloseButton = styled(View)`
  cursor: pointer;
  display: block;
`;

const InfoView = styled(View)`
  background: #d8d8d8;
  border: 1px #979797 solid;
  padding: 10px;
`;



// WEBPACK FOOTER //
// ./src/pages/AddMemoModal.tsx